import _defineProperty from "/builds/talkbox/teamwork/teamwork-product-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export { ThemeProvider } from "styled-components";
import { variant as r, system as o, layout as e, get as a } from "styled-system";
import n from "prop-types";
var s = r({
  prop: "size",
  key: "inputSizes"
});
s.propTypes = {
  size: n.oneOf(["s", "m", "l"])
};
var t = r({
  prop: "transitions",
  key: "transitions"
}),
    i = o({
  width: {
    property: "width",
    scale: "sizes",
    transform: function transform(r, o) {
      return a(o, r, !function (r) {
        return "number" == typeof r && !isNaN(r);
      }(r) || r > 1 ? r : 100 * r + "%");
    }
  },
  height: {
    property: "height",
    scale: "sizes"
  },
  minWidth: {
    property: "minWidth",
    scale: "sizes"
  },
  minHeight: {
    property: "minHeight",
    scale: "sizes"
  },
  maxWidth: {
    property: "maxWidth",
    scale: "sizes"
  },
  maxHeight: {
    property: "maxHeight",
    scale: "sizes"
  },
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  display: !0,
  verticalAlign: !0
});
i.propTypes = e.propTypes;
var l = [0, "4px", "8px", "16px", "32px", "64px"];
l.xs = l[1], l.s = l[2], l.m = l[3], l.l = l[4], l.xl = l[5];
var p = ["0.75rem", "0.875rem", "1.0rem", "1.25rem", "1.5rem", "2.0rem", "2.5rem"];
p.h1 = p[6], p.h2 = p[5], p.h3 = p[4], p.h4 = p[3], p.h5 = p[2], p.h6 = p[1], p.body = p[2], p.xxs = p[0], p.xs = p[1], p.s = p[2], p.m = p[3], p.l = p[4], p.xl = p[5], p.xxl = p[6];

var c = {
  breakpoints: ["480px", "720px", "960px", "1280px"],
  fontSizes: p,
  space: l,
  colors: {
    primary: "#0b3f73",
    primaryLightVariant: "#63a4ff",
    primaryDarkVariant: "#1F1F1F",
    secondary: "#eceff1",
    secondaryLightVariant: "#ffffff",
    secondaryDarkVariant: "#cfd8dc",
    error: "#e91e63",
    errorLightVariant: "#f5407d",
    errorDarkVariant: "#c91854",
    link: "#0d47a1",
    background: "#ffffff",
    surface: "#ffffff",
    input: "#F7F7F7",
    onPrimary: "#ffffff",
    onSecondary: "#29434e",
    onBackground: "#263145",
    onSurface: "#263145",
    onInput: "#000000",
    onError: "#ffffff",
    border: "rgba(0,0,0,0.1)",
    borderLightVariant: "rgba(255.0,255.0,255.0,0.2)"
  },
  fonts: {
    heading: '"Roboto Slab", serif',
    body: "'Roboto', -apple-system,BlinkMacSystemFont,'Segoe UI','PingFang SC','Hiragino Sans GB','Microsoft YaHei','Helvetica Neue',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
    monospace: "Menlo, monospace"
  },
  fontWeights: {
    body: 400,
    subtitle: 700,
    heading: 700,
    bold: 700
  },
  lineHeights: {
    body: 1.5,
    subtitle: 1.25,
    heading: 1.25
  },
  borderWidths: {
    separator: "1px",
    surface: "1px",
    input: "2px"
  },
  shadows: {
    small: "0 0 4px rgba(0, 0, 0, .125)",
    large: "0 0 24px rgba(0, 0, 0, .125)"
  },
  radii: {
    s: "2px",
    m: "4px",
    l: "8px"
  },
  transitions: {
    box: "all 0.2s ease",
    input: "all 0.2s ease",
    button: "all 0.2s ease"
  }
},
    b = _objectSpread(_objectSpread({}, c), {}, {
  buttons: {
    primary: {
      "--button-bg": c.colors.primary,
      backgroundColor: c.colors.primary,
      color: c.colors.onPrimary,
      "&:hover, &:focus": {
        "--button-bg": c.colors.primaryDarkVariant,
        backgroundColor: c.colors.primaryDarkVariant
      },
      ".spinner": {
        backgroundColor: "var(--button-bg)"
      }
    },
    secondary: {
      "--button-bg": c.colors.secondary,
      backgroundColor: c.colors.secondary,
      color: c.colors.onSecondary,
      "&:hover, &:focus": {
        "--button-bg": c.colors.secondaryDarkVariant,
        backgroundColor: c.colors.secondaryDarkVariant
      },
      ".spinner": {
        backgroundColor: "var(--button-bg)"
      }
    },
    plain: {
      "--button-bg": "#EEEEEE",
      backgroundColor: "#EEEEEE",
      color: "rgba(0,0,0,0.9)",
      "&:hover, &:focus": {
        "--button-bg": "#DDDDDD",
        backgroundColor: "#DDDDDD"
      },
      ".spinner": {
        backgroundColor: "var(--button-bg)"
      }
    },
    danger: {
      "--button-bg": c.colors.error,
      backgroundColor: c.colors.error,
      color: c.colors.onError,
      "&:hover, &:focus": {
        "--button-bg": c.colors.errorDarkVariant,
        backgroundColor: c.colors.errorDarkVariant
      },
      ".spinner": {
        backgroundColor: "var(--button-bg)"
      }
    },
    icon: {
      borderRadius: c.radii.m,
      "--button-bg": "transparent",
      backgroundColor: "transparent",
      color: c.colors.primary,
      "&:hover, &:focus": {
        "--button-bg": "transparent",
        backgroundColor: "transparent"
      },
      "> .spinner": {
        backgroundColor: "var(--button-bg)"
      }
    }
  },
  inputSizes: {
    s: {
      fontSize: c.fontSizes.xs,
      minHeight: "1.75rem"
    },
    m: {
      fontSize: c.fontSizes.s,
      minHeight: "2.25rem"
    },
    l: {
      fontSize: c.fontSizes.m,
      minHeight: "2.75rem"
    }
  },
  borders: {
    light: "".concat(c.borderWidths.surface, " solid ").concat(c.colors.border),
    input: "".concat(c.borderWidths.input, " solid ").concat(c.colors.border)
  }
});

export { b as ThemeFuji, s as inputSizes, i as layout, t as transitions };